import axios from 'axios';

// 1. Create the base instance
const api = axios.create({
  baseURL: '/api', // Handles proxying to your backend via package.json-Correct: automatically uses https://BV.africa/api in production
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Attach token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('buniverse_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Catch 401 Unauthorized globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn('Session expired or unauthorized. Logging out...');
      
      // Wipe the cryptographic identity completely
      localStorage.removeItem('buniverse_token');
      localStorage.removeItem('buniverse_user');
      
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;